import "./css/exhibitions.css"
import Footer from "./Footer.js"

export default function Exhibitions() {
    return <div></div>
}